import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { FertileEggBaseService } from './fertileegg-base.service';

@Injectable()
export class FertileEggService extends FertileEggBaseService {
  constructor() {
    const http = inject(HttpClient);

    super(http);
  }
}
